exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".download-prod-option input{margin-left:0!important;top:1px!important}.download-prod-option label{margin-right:5px}.download-prod-option{float:right!important;margin:0!important}.iframe-checkbox-div{float:right;margin:0 36px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/src/views/RecordsDetailsModalView.css
// module id = 1993
// module chunks = 0